new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
        footer: {
            facebook: true, // Facebook icon
            instagram: true, // Instagram icon
            whatsapp: true, // Instagram icon
            youtube: true, // Instagram icon
            ssl: true, // SSL icon
            google: true, // Google safe browser icon
            visa: true, // Visa payment method icon
            diners: true, // Diners payment method icon
            amex: true, // Amex payment method icon
            mastercard: true, // Mastercard payment method icon
            aura: true, // Aura payment method icon
            hipercard: true, // Hipercard payment method icon
            elo: true, // Elo payment method icon
            shoppub: true, // Shoppub plataform icon
        }
    },
});

$(document).ready(function () {

    if (window.matchMedia("(max-width: 991px)").matches) {
        const footerSection = document.querySelectorAll('.footer-section');
        if(footerSection.length) {
            footerSection.forEach((item) => {
                let footerTitle = item.querySelector('.footer-title');
                let footerContent = item.querySelector('.footer-section--content');
                if(footerTitle && footerContent) {
                    footerTitle.addEventListener('click', () => {
                        footerTitle.classList.toggle('active');
                        footerContent.classList.toggle('active');
                    });
                }
            });
        }
    }

});